<template>
  <div>
    <section-header
      media="/img/backs/ivelopment.jpg"
      title="Privacy Policy"
    ></section-header>

    <div class="container iv-privacy-policy-page">
      <div class="iv-raised-box">
        <div class="mb-4">
          <p>{{ $t("privacy_policy.privacy_policy.p1") }}</p>
          <p>{{ $t("privacy_policy.privacy_policy.p2") }}</p>
          <p>{{ $t("privacy_policy.privacy_policy.p3") }}</p>
          <p>{{ $t("privacy_policy.privacy_policy.p4") }}</p>
        </div>

        <div class="row mt-5">
          <div class="col-lg-4">
            <div>
              <h3 class="text-left">
                {{ $t("privacy_policy.overview.title") }}
              </h3>

              <ul class="list-group">
                <li>
                  <a href="#info" class="list-item-group">{{
                    $t("privacy_policy.overview.i1")
                  }}</a>
                </li>
                <li>
                  <a href="#use" class="list-item-group">{{
                    $t("privacy_policy.overview.i2")
                  }}</a>
                </li>
                <li>
                  <a href="#transfer" class="list-item-group">{{
                    $t("privacy_policy.overview.i3")
                  }}</a>
                </li>
                <li>
                  <a href="#disclosure" class="list-item-group">{{
                    $t("privacy_policy.overview.i4")
                  }}</a>
                </li>
                <li>
                  <a href="#security" class="list-item-group">{{
                    $t("privacy_policy.overview.i5")
                  }}</a>
                </li>
                <li>
                  <a href="#service" class="list-item-group">{{
                    $t("privacy_policy.overview.i6")
                  }}</a>
                </li>
                <li>
                  <a href="#links" class="list-item-group">{{
                    $t("privacy_policy.overview.i7")
                  }}</a>
                </li>
                <li>
                  <a href="#children" class="list-item-group">{{
                    $t("privacy_policy.overview.i8")
                  }}</a>
                </li>
                <li>
                  <a href="#changes" class="list-item-group">{{
                    $t("privacy_policy.overview.i9")
                  }}</a>
                </li>
                <li>
                  <a href="#contact" class="list-item-group">{{
                    $t("privacy_policy.overview.i10")
                  }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="mb-4" id="info">
              <h3>{{ $t("privacy_policy.c1.title") }}</h3>

              <h5>{{ $t("privacy_policy.c1.personal_data.title") }}</h5>
              <p>
                {{ $t("privacy_policy.c1.personal_data.p") }}
              </p>
              <ul>
                <li>{{ $t("privacy_policy.c1.personal_data.i1") }}</li>
                <li>{{ $t("privacy_policy.c1.personal_data.i2") }}</li>
                <li>{{ $t("privacy_policy.c1.personal_data.i3") }}</li>
                <li>{{ $t("privacy_policy.c1.personal_data.i4") }}</li>
                <li>{{ $t("privacy_policy.c1.personal_data.i5") }}</li>
              </ul>

              <h5>{{ $t("privacy_policy.c1.usage_data.title") }}</h5>
              <p>
                {{ $t("privacy_policy.c1.usage_data.p") }}
              </p>

              <h5>{{ $t("privacy_policy.c1.tracking_data.title") }}</h5>
              <p>
                {{ $t("privacy_policy.c1.tracking_data.i1") }}
              </p>

              <p>
                {{ $t("privacy_policy.c1.tracking_data.i2") }}
              </p>

              <p>
                {{ $t("privacy_policy.c1.tracking_data.i3") }}
              </p>

              <p>
                {{ $t("privacy_policy.c1.tracking_data.i4") }}
              </p>

              <dl>
                <dt>{{ $t("privacy_policy.c1.tracking_data.e1") }}</dt>
                <dd>{{ $t("privacy_policy.c1.tracking_data.e2") }}</dd>
                <dt>{{ $t("privacy_policy.c1.tracking_data.e3") }}</dt>
                <dd>{{ $t("privacy_policy.c1.tracking_data.e4") }}</dd>
                <dt>{{ $t("privacy_policy.c1.tracking_data.e5") }}</dt>
                <dd>{{ $t("privacy_policy.c1.tracking_data.e6") }}</dd>
              </dl>
            </div>

            <div class="mb-4" id="use">
              <h3>{{ $t("privacy_policy.c2.title") }}</h3>

              <p>{{ $t("privacy_policy.c2.p") }}</p>

              <ul>
                <li>{{ $t("privacy_policy.c2.i1") }}</li>
                <li>{{ $t("privacy_policy.c2.i2") }}</li>
                <li>{{ $t("privacy_policy.c2.i3") }}</li>
                <li>{{ $t("privacy_policy.c2.i4") }}</li>
                <li>{{ $t("privacy_policy.c2.i5") }}</li>
                <li>{{ $t("privacy_policy.c2.i6") }}</li>
                <li>{{ $t("privacy_policy.c2.i7") }}</li>
              </ul>
            </div>

            <div class="mb-4" id="transfer">
              <h3>{{ $t("privacy_policy.c3.title") }}</h3>

              <p>
                {{ $t("privacy_policy.c3.p1") }}
              </p>

              <p>
                {{ $t("privacy_policy.c3.p2") }}
              </p>

              <p>
                {{ $t("privacy_policy.c3.p3") }}
              </p>

              <p>
                {{ $t("privacy_policy.c3.p4") }}
              </p>
            </div>

            <div class="mb-4" id="disclosure">
              <h3>{{ $t("privacy_policy.c4.title") }}</h3>

              <h4>{{ $t("privacy_policy.c4.subtitle") }}</h4>
              <p>{{ $t("privacy_policy.c4.p") }}</p>

              <ul>
                <li>{{ $t("privacy_policy.c4.i1") }}</li>
                <li>{{ $t("privacy_policy.c4.i2") }}</li>
                <li>{{ $t("privacy_policy.c4.i3") }}</li>
                <li>{{ $t("privacy_policy.c4.i4") }}</li>
                <li>{{ $t("privacy_policy.c4.i5") }}</li>
              </ul>
            </div>

            <div class="mb-4" id="security">
              <h3>{{ $t("privacy_policy.c5.title") }}</h3>

              <p>
                {{ $t("privacy_policy.c5.p") }}
              </p>
            </div>

            <div class="mb-4" id="service">
              <h3>{{ $t("privacy_policy.c6.title") }}</h3>

              <p>
                {{ $t("privacy_policy.c6.p1") }}
              </p>

              <p>
                {{ $t("privacy_policy.c6.p2") }}
              </p>
            </div>

            <div class="mb-4" id="links">
              <h3>{{ $t("privacy_policy.c7.title") }}</h3>

              <p>
                {{ $t("privacy_policy.c7.p1") }}
              </p>

              <p>
                {{ $t("privacy_policy.c7.p2") }}
              </p>
            </div>

            <div class="mb-4" id="children">
              <h3>{{ $t("privacy_policy.c8.title") }}</h3>

              <p>
                {{ $t("privacy_policy.c8.p1") }}
              </p>

              <p>
                {{ $t("privacy_policy.c8.p2") }}
              </p>
            </div>

            <div class="mb-4" id="changes">
              <h3>{{ $t("privacy_policy.c9.title") }}</h3>

              <p>
                {{ $t("privacy_policy.c9.p1") }}
              </p>

              <p>
                {{ $t("privacy_policy.c9.p2") }}
              </p>

              <p>
                {{ $t("privacy_policy.c9.p3") }}
              </p>
            </div>

            <div id="contact">
              <h3>{{ $t("privacy_policy.c10.title") }}</h3>

              <p v-html="$t('privacy_policy.c10.p')"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Emergence from "emergence.js";
import Rellax from "rellax";

export default {
  name: "privacy-policy",
  mounted() {},
};
</script>
